module.exports = __webpack_public_path__ + "assets/img/addTask_btn2.d7145215.png";